import { createContext, useContext } from "react";

/**
 * Theme preference is per-browser (localStorage), never shared across users.
 * Dashboard / login / platform use APP key; marketing home + quote flows use PUBLIC key
 * so toggling appearance in the dashboard does not change `/` or `/quote`.
 */
export const THEME_STORAGE_KEY_APP = "clibbins-color-mode";
export const THEME_STORAGE_KEY_PUBLIC = "clibbins-color-mode-public";

/** @deprecated alias for THEME_STORAGE_KEY_APP */
export const THEME_STORAGE_KEY = THEME_STORAGE_KEY_APP;

/** Persists via `localStorage` from Root in `index.js`. */
export const ThemeModeContext = createContext({
  mode: "light",
  setColorMode: () => {},
});

export function useColorMode() {
  return useContext(ThemeModeContext);
}
